module.exports = __webpack_public_path__ + "img/whatapp.2f4729c0.png";